(() => {
  const popConvertId = 'pop-convert-app';
  let guardedPopConvert = null;
  let guardedPopConvertState = null;
  let popConvertObserver = null;

  const capturePopConvertState = (element) => ({
    styles: ['display', 'visibility', 'pointer-events'].map((property) => ({
      property,
      value: element.style.getPropertyValue(property),
      priority: element.style.getPropertyPriority(property),
    })),
    ariaHidden: element.hasAttribute('aria-hidden') ? element.getAttribute('aria-hidden') : null,
  });

  const releasePopConvert = () => {
    popConvertObserver?.disconnect();
    if (guardedPopConvert && guardedPopConvertState) {
      guardedPopConvertState.styles.forEach(({ property, value, priority }) => {
        if (value) guardedPopConvert.style.setProperty(property, value, priority);
        else guardedPopConvert.style.removeProperty(property);
      });
      if (guardedPopConvertState.ariaHidden === null) guardedPopConvert.removeAttribute('aria-hidden');
      else guardedPopConvert.setAttribute('aria-hidden', guardedPopConvertState.ariaHidden);
    }
    guardedPopConvert = null;
    guardedPopConvertState = null;
  };

  const suppressPopConvert = (element) => {
    const hiddenStyles = {
      display: 'none',
      visibility: 'hidden',
      'pointer-events': 'none',
    };

    Object.entries(hiddenStyles).forEach(([property, value]) => {
      if (element.style.getPropertyValue(property) === value && element.style.getPropertyPriority(property) === 'important') {
        return;
      }
      element.style.setProperty(property, value, 'important');
    });
    if (element.getAttribute('aria-hidden') !== 'true') element.setAttribute('aria-hidden', 'true');
  };

  const guardPopConvert = (element = document.getElementById(popConvertId)) => {
    if (!element || element === guardedPopConvert) return Boolean(element);

    releasePopConvert();
    guardedPopConvert = element;
    guardedPopConvertState = capturePopConvertState(element);
    suppressPopConvert(element);
    popConvertObserver = new MutationObserver(() => {
      if (element.id !== popConvertId) {
        releasePopConvert();
        return;
      }
      suppressPopConvert(element);
    });
    popConvertObserver.observe(element, { attributes: true, attributeFilter: ['class', 'id', 'style', 'aria-hidden'] });
    return true;
  };

  const start = () => {
    guardPopConvert();
    const documentObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          if (mutation.target instanceof Element && mutation.target.id === popConvertId) guardPopConvert(mutation.target);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.id === popConvertId) guardPopConvert(node);
          guardPopConvert(node.querySelector(`#${popConvertId}`));
        });
      });
    });
    const observeDocument = () => documentObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['id'],
    });
    observeDocument();
    window.addEventListener('pageshow', () => {
      observeDocument();
      guardPopConvert();
    });
    window.addEventListener('pagehide', () => {
      documentObserver.disconnect();
      releasePopConvert();
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-bck-cart-value-cta]');
      if (!link) return;

      const eventName = 'bck_cart_box_value_clicked';
      try {
        window.Shopify?.analytics?.publish?.(eventName, {
          event: eventName,
          event_id: window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`,
          destination: link.getAttribute('href')
        });
      } catch (error) {
        // Cart navigation must remain available if analytics is unavailable.
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
